// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"F_t3 h_jm h_fm h_fq h_fB h_dJ h_t","menuItemSub":"F_t4 h_dQ h_fm h_fB","menuMainLink":"F_t5 h_jn h_hh","menuLink":"F_t6 h_jn h_hh","Link":"F_sM x_sM x_r2 x_sm"};